import { InteractionLogService } from './interaction-log.service';

/**
 * InteractionLog is a method decorator factory
 * It returns a method decorator
 */

export function InteractionLogDecorator(name: string, event: string, logData = false): MethodDecorator {
  return (target: any, propertyKey: string, descriptor: PropertyDescriptor) => {
    const method = descriptor.value;

    descriptor.value = function (...args: any[]) {
      const instance = InteractionLogService.instance();
      const data: any = (logData && args) || undefined;
      instance && instance.interactionLog(name, event, data);
      return method.call(this, ...args);
    };
  };
}
